import { defineAction, expression } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import { reportFormatSchema } from '~/utils/server/report'
import materialDeliveryReportAction from './materialDeliveryReport.action.json' with { type: 'json' }
import { z } from 'zod'
import { materialObject, materialTypeValues } from '../../material/materialObject'
import { materialDeliveryObject } from '../materialDeliveryObject'

const materialDeliveryReportDefinition = defineAction({
  ...materialDeliveryReportAction,

  input: z.object({
    format: reportFormatSchema,
    citizenId: materialDeliveryObject.shape.citizenId.nullish(),
    materialId: materialObject.shape.id.nullish(),
    materialType: materialTypeValues.nullish(),
    startDate: dateOrIsoString().nullish(),
    endDate: dateOrIsoString().nullish(),
  }),
  output: z.any(),
})

export default materialDeliveryReportDefinition
